/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputFiltersSelectStringItem
 */
export interface OutputFiltersSelectStringItem {
    /**
     * 
     * @type {string}
     * @memberof OutputFiltersSelectStringItem
     */
    subtitle: string;
    /**
     * 
     * @type {string}
     * @memberof OutputFiltersSelectStringItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OutputFiltersSelectStringItem
     */
    value: string;
}

/**
 * Check if a given object implements the OutputFiltersSelectStringItem interface.
 */
export function instanceOfOutputFiltersSelectStringItem(value: object): boolean {
    if (!('subtitle' in value)) return false;
    if (!('title' in value)) return false;
    if (!('value' in value)) return false;
    return true;
}

export function OutputFiltersSelectStringItemFromJSON(json: any): OutputFiltersSelectStringItem {
    return OutputFiltersSelectStringItemFromJSONTyped(json, false);
}

export function OutputFiltersSelectStringItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputFiltersSelectStringItem {
    if (json == null) {
        return json;
    }
    return {
        
        'subtitle': json['subtitle'],
        'title': json['title'],
        'value': json['value'],
    };
}

export function OutputFiltersSelectStringItemToJSON(value?: OutputFiltersSelectStringItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subtitle': value['subtitle'],
        'title': value['title'],
        'value': value['value'],
    };
}

